import React, {Fragment, useEffect, useRef, useState, useMemo } from 'react';
import {connect} from 'react-redux';
import Cookie from 'js-cookie';
import {Declension} from '../../../services/services/Declension';
import GeoService from '../../../services/services/GeoService';
import pushGA from '../../../services/utils/pushGA';

import {injectIntl} from '@s7ui-kit/s7ui-kit';
import requestUtil from '../../../services/services/requestUtil';
import isEmpty from 'lodash/isEmpty';
import { ShowMore } from '../../main/ShowMore';
import useIntersectionObserver from  '../../../hooks/useIntersection';

import '../new-mainpage/direct-directions.scss';
import {
    analyticsMainPageBlockClick,
    analyticsMainPageBlockLoaded,
    analyticsMainPageBlockShown
} from '../../../services/analytics/analyticsMainpage';

const frontVersion = FRONTEND_VERSION;
const MIN_DIRECT_ROUTES = 4;
const mapStateToProps = ({App, User}) => ({App, User});

const makeId = length => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

const seoPageServicePrefix = process.env.REACT_APP_SEO_PAGE_SERVICE;

let alreadyShowned = false;

const DirectDirections = (props) => {
    const {App: {lang, deviceWidth, currency}} = props;
    const { words, getMessage } = props;
    const declension = new Declension(words, getMessage);

    const [ airport, setAirport ] = useState(GeoService.getUserCityByGeo().airportCode);
    const [ directRoutes, setDirectRoutes ] = useState([]);
    const [ transferRoutes, setTransferRoutes ] = useState([]);
    const [ gotRoutes, setGotRoutes ] = useState(false);

    let DirectDirections = useRef(null);

    const ref = useRef(null);
    const entry = useIntersectionObserver(ref, { freezeOnceVisible: false });
    const isVisible = !!entry?.isIntersecting;
    let alreadySent = useRef(false);

    useEffect(() => {
        if(gotRoutes && isVisible && !alreadySent?.current){
            alreadySent.current = true;
            setTimeout(()=> {
                analyticsMainPageBlockShown({
                    step: 'flights_from',
                    items: ecomParamsForGA,
                    ux: 'auto_open'
                })
            }, 2000);
        }
    }, [ entry ]);

    useEffect(() => {
        setGotRoutes(false);
        const airport_iata = Cookie.get('airport');
        setAirport(airport_iata);
        alreadySent.current = false;

        const searchParams = new URLSearchParams('');
        searchParams.append('curr', currency);
        requestUtil(`${seoPageServicePrefix}/${lang}/blocks/rotator/${airport_iata}?${searchParams}`)
            .then(response => {
                const directRoutesData = response.directRoutes;
                const transferRoutesData = response.transferRoutes;

                if (directRoutesData) {
                    setDirectRoutes(directRoutesData);
                }
                if (transferRoutesData) {
                    setTransferRoutes(transferRoutesData);
                }
                setGotRoutes(true)
            })

    }, [currency]);

    useEffect(()=> {
        if(directRoutes.length === 0){
            return;
        }
        analyticsMainPageBlockLoaded({
            step: 'flights_from',
            items: ecomParamsForGA
        });
    }, [gotRoutes]);

    const ecomParamsForGA = useMemo(() => {
        const directArray = [];

        directRoutes.slice(0, 12).forEach((item, index) => {
            directArray.push({
                item_id: item.to?.iata,
                item_name: 'flights_from',
                affiliation: 'content, hermes, minprice',
                index: index + 1,
                location_id: 's7_main'
            })
        });
        const directRoutesCount = directRoutes.slice(0, 12).length;

        if(directRoutes.length < MIN_DIRECT_ROUTES && !isEmpty(transferRoutes)){
            transferRoutes.slice(0, 12).forEach((item, index) => {
                directArray.push({
                    item_id: item.to?.iata,
                    item_name: 'flights_from',
                    affiliation:  'content, hermes, minprice',
                    index: directRoutesCount + index + 1,
                    location_id: 's7_main'
                })
            });
        }
        return directArray;
    }, [ directRoutes, transferRoutes ]);

    const onClickArticle = ({item, index}) => {
        analyticsMainPageBlockClick({
            step: 'flights_from',
            items: [{
                item_id: item.to?.iata,
                item_name: 'flights_from',
                affiliation:  'content, hermes, minprice',
                index: index + 1,
                location_id: 's7_main'
            }]
        })
    };

    useEffect(() => {
        if(directRoutes.length > 0) {
            const callback = () =>  {
                if (alreadyShowned) {
                    return;
                }

                alreadyShowned = true;

                sendGaEvent('Load_Flights', 1, 'all');
            };

            const options = {
                rootMargin: '0px',
                threshold: 1.0
            };

            const observer = new IntersectionObserver(callback, options);

            observer.observe(DirectDirections);
        }
    }, [transferRoutes]);

    const sendGaEvent = (eventAction, eventInteraction, flightType) => {
        const routesLength =
            flightType === 'all' ? directRoutes.length + transferRoutes.length
            : flightType === 'direct' ? directRoutes.length
                : flightType === 'transfer' ? transferRoutes.length
                    : 0;
        const transferCity = transferRoutes.length ? transferRoutes[0].from.iata : '';
        const directRoutesArr = [];
        const transferRoutesArr = [];
        let routes;
        let eventLabel;

        if (directRoutes.length) {
            directRoutes.map(item => {
                directRoutesArr.push(item.to.iata);
            })
        }

        if (transferRoutes.length) {
            transferRoutes.map(item => {
                transferRoutesArr.push(item.to.iata);
            })
        }

        if (flightType === 'all') {
            if (directRoutesArr.length && transferRoutesArr.length) {
                routes = `DIRECT:${directRoutesArr.join(',')};TRANSFER:${transferRoutesArr.join(',')}`;
                eventLabel = `FROM:${airport},${transferCity}`
            } else {
                routes = `DIRECT:${directRoutesArr.join(',')};TRANSFER:none`;
                eventLabel = `FROM:${airport}`
            }
        } else if (directRoutesArr.length && flightType === 'direct') {
            routes = `DIRECTIONS:${directRoutesArr.join(',')}`;
            eventLabel = `FROM:${airport}`
        } else if (transferRoutesArr.length && flightType === 'transfer') {
            routes = `DIRECTIONS:${transferRoutesArr.join(',')}`;
            eventLabel = `FROM:${transferCity}`
        } else {
            routes = 'undefined';
            eventLabel = 'undefined';
        }

        pushGA(
            'PORTAL Rotator',
            eventAction,
            eventLabel,
            {
                eventValue: routesLength,
                flightDetail: routes,
                eventInteraction: eventInteraction
            }
        )
    };

    const getCurrentCurrency = () => {
        switch (currency) {
            case 'RUB':
                return getMessage(words, 'com.s7.rotator.currency.rub');
                break;
            case 'USD':
                return getMessage(words, 'com.s7.rotator.currency.usd');
                break;
            case 'EUR':
                return getMessage(words, 'com.s7.rotator.currency.eur');
                break;
            case 'CNY':
                return getMessage(words, 'com.s7.rotator.currency.cny');
                break;
            default:
                return getMessage(words, 'com.s7.rotator.currency.rub');
        }
    };


    const renderShowMore = () => {
        return <ShowMore
            text={getMessage(words, 'com.s7.header.schedule')}
            link={`/${lang}/timetable/?departureCity=${airport}`}
            onClick={() => {
                sendGaEvent('Click_Timetable', 0, 'direct');
                analyticsMainPageBlockClick({
                    step: 'flights_from',
                    items: [{
                        item_id: 'all',
                        item_name: 'flights_from',
                        affiliation:  'content, hermes, minprice',
                        index: undefined,
                        location_id: 's7_main'
                    }]
                })
            }}
            className={'direct-directions__link'}
        />
    };

    return (
        <div
            ref={ref => {
                if (!ref) {
                    return;
                }

                DirectDirections = ref;
            }}
        >
            {
                !isEmpty(directRoutes) &&
                <section
                    className={'direct-directions'}
                    id={'direct-directions'}
                    ref={ref}
                >
                    <div className={'direct-directions__wrapper'}>
                        <div className={'direct-directions__header'}>
                            <a
                                href={`/${lang}/routes/${directRoutes[0].from.iata}/`}
                                className={'direct-directions__header-title'}
                                onClick={() => {
                                    sendGaEvent('Click_CityRoutes', 0, 'direct')
                                }}
                            >
                                {
                                    directRoutes[0].fromName &&
                                    `${getMessage(words, 'com.s7.rotator.flightfrom')} ${declension.fromCity({ city: directRoutes[0].fromName, iata: directRoutes[0].from.iata })}`
                                }

                            </a>
                            { deviceWidth >= 768 && renderShowMore()}
                        </div>
                        <div className={'direct-directions__items'}>
                            {
                                directRoutes.slice(0, 12).map((item, index) => {
                                    return(
                                        <a
                                            key={makeId(24)}
                                            className={'direct-directions__item'}
                                            href={`/${lang}/flight/from/${airport}/to/${item.to.iata}/`}
                                            onClick={() => {
                                                pushGA(
                                                    'PORTAL Rotator',
                                                    'Click_Flight',
                                                    `FROM:${item.from.iata};TO:${item.to.iata}`,
                                                    {
                                                        eventValue: item.minPrice.rt ? item.minPrice.rt : 0,
                                                        flightDetail: item.minPrice.rt ? `MIN:${item.minPrice.rt}` : `MIN:see_prices`,
                                                        eventInteraction: 0,
                                                    }
                                                )
                                                onClickArticle({item, index});
                                            }}
                                        >
                                            <div className={'direct-directions__description'}>
                                                {
                                                    deviceWidth > 767 ?
                                                        <Fragment>
                                                            <p className={'direct-directions__title'}>
                                                                { item.toName }
                                                            </p>
                                                            <p className={'direct-directions__subtitle'}
                                                               dangerouslySetInnerHTML={{
                                                                   __html: `${getMessage(words, 'com.s7.generated.page.from')} ${declension.fromCity({ city: item.fromName, iata: item.from.iata })} ${getMessage(words, 'com.s7.main.page.special.offers.city.return')}`
                                                               }}
                                                            />
                                                            {
                                                                (!isEmpty(item.minPrice) && item.minPrice.rtFormat) ? <p className={'direct-directions__price'}>
                                                                        {
                                                                            `${getMessage(words, 'com.s7.requests.req_tracing.from')} ${item.minPrice.rtFormat} ${getCurrentCurrency()}`
                                                                        }
                                                                    </p>
                                                                    :
                                                                    <p className={'direct-directions__check-price'}>
                                                                        { getMessage(words, 'com.s7.autogenerated.get.price') }
                                                                    </p>
                                                            }
                                                        </Fragment>
                                                        :
                                                        <Fragment>
                                                            <div className={'direct-directions__left'}>
                                                                <p className={'direct-directions__title'}>
                                                                    { item.toName }
                                                                </p>
                                                                <p className={'direct-directions__subtitle'}
                                                                   dangerouslySetInnerHTML={{
                                                                       __html: `${getMessage(words, 'com.s7.generated.page.from')} ${declension.fromCity({ city: item.fromName, iata: item.from.iata })} ${getMessage(words, 'com.s7.main.page.special.offers.city.return')}`
                                                                   }}
                                                                />
                                                            </div>
                                                            <div className={'direct-directions__right'}>
                                                                {
                                                                    (!isEmpty(item.minPrice) && item.minPrice.rtFormat) ? <p className={'direct-directions__price'}>
                                                                            {
                                                                                `${getMessage(words, 'com.s7.requests.req_tracing.from')} ${item.minPrice.rtFormat} ${getCurrentCurrency()}`
                                                                            }
                                                                        </p>
                                                                        :
                                                                        <p className={'direct-directions__check-price'}>
                                                                            { getMessage(words, 'com.s7.autogenerated.get.price') }
                                                                        </p>
                                                                }
                                                            </div>
                                                        </Fragment>
                                                }
                                            </div>
                                        </a>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {
                        (directRoutes.length < MIN_DIRECT_ROUTES && !isEmpty(transferRoutes)) && <div className={'direct-directions__wrapper'}>
                            <div className={'direct-directions__header'}>
                                <a
                                    href={`/${lang}/routes/${transferRoutes[0].from.iata}/`}
                                    className={'direct-directions__header-title'}
                                    onClick={() => {
                                        sendGaEvent('Click_CityRoutes', 0, 'transfer')
                                    }}
                                >
                                    {
                                        transferRoutes[0].fromName &&
                                        `${getMessage(words, 'com.s7.rotator.flightfrom')} ${declension.fromCity({ city: transferRoutes[0].fromName, iata: transferRoutes[0].from.iata })}`
                                    }
                                </a>
                            </div>
                            <div className={'direct-directions__items'}>
                                {
                                    transferRoutes.slice(0, 12).map((item, index) => {
                                        return(
                                            <a
                                                key={makeId(24)}
                                                className={'direct-directions__item'}
                                                href={`/${lang}/flight/from/${item.from.iata}/to/${item.to.iata}/`}
                                                onClick={() => {
                                                    pushGA(
                                                        'PORTAL Rotator',
                                                        'Click_Flight',
                                                        `FROM:${item.from.iata};TO:${item.to.iata}`,
                                                        {
                                                            eventValue: item.minPrice.rt ? item.minPrice.rt : 0,
                                                            flightDetail: item.minPrice.rt ? `MIN:${item.minPrice.rt}` : `MIN:see_prices`,
                                                            eventInteraction: 0,
                                                        }
                                                    )
                                                    onClickArticle({item, index: index + directRoutes.slice(0, 12).length});
                                                }}
                                            >
                                                <div className={'direct-directions__description'}>
                                                    {
                                                        deviceWidth > 767 ?
                                                            <Fragment>
                                                                <p className={'direct-directions__title'}>
                                                                    { item.toName }
                                                                </p>
                                                                <p className={'direct-directions__subtitle'}
                                                                   dangerouslySetInnerHTML={{
                                                                       __html: `${getMessage(words, 'com.s7.generated.page.from')} ${declension.fromCity({ city: item.fromName, iata: item.from.iata })} ${getMessage(words, 'com.s7.main.page.special.offers.city.return')}`
                                                                   }}
                                                                />
                                                                {
                                                                    (!isEmpty(item.minPrice) && item.minPrice.rtFormat) ? <p className={'direct-directions__price'}>
                                                                            {
                                                                                `${getMessage(words, 'com.s7.requests.req_tracing.from')} ${item.minPrice.rtFormat} ${getCurrentCurrency()}`
                                                                            }
                                                                        </p>
                                                                        :
                                                                        <p className={'direct-directions__check-price'}>
                                                                            { getMessage(words, 'com.s7.autogenerated.get.price') }
                                                                        </p>
                                                                }
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <div className={'direct-directions__left'}>
                                                                    <p className={'direct-directions__title'}>
                                                                        { item.toName }
                                                                    </p>
                                                                    <p className={'direct-directions__subtitle'}
                                                                       dangerouslySetInnerHTML={{
                                                                           __html: `${getMessage(words, 'com.s7.generated.page.from')} ${declension.fromCity({ city: item.fromName, iata: item.from.iata })} ${getMessage(words, 'com.s7.main.page.special.offers.city.return')}`
                                                                       }}
                                                                    />
                                                                </div>
                                                                <div className={'direct-directions__right'}>
                                                                    {
                                                                        (!isEmpty(item.minPrice) && item.minPrice.rtFormat) ? <p className={'direct-directions__price'}>
                                                                                {
                                                                                    `${getMessage(words, 'com.s7.requests.req_tracing.from')} ${item.minPrice.rtFormat} ${getCurrentCurrency()}`
                                                                                }
                                                                            </p>
                                                                            :
                                                                            <p className={'direct-directions__check-price'}>
                                                                                { getMessage(words, 'com.s7.autogenerated.get.price') }
                                                                            </p>
                                                                    }
                                                                </div>
                                                            </Fragment>
                                                    }
                                                </div>
                                            </a>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    }

                    { deviceWidth < 768 && !isEmpty(directRoutes) && renderShowMore()}
                </section>
            }
        </div>

    );
};

export default injectIntl(connect(mapStateToProps)(React.memo(DirectDirections)));